export default "/images/img_1.png?491405bb269c0bfe63413c0e3810f742";